import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  TitleStrategy,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { PUBLIC_APP_NAME } from './brand';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    // 1) Prefer explicit route.title (Angular's "title" route property)
    let t = this.buildTitle(snapshot);

    // 2) Fallback: derive from route params (entries/:module/:slug)
    if (!t) {
      const leaf = this.getLeaf(snapshot.root);
      const mod = leaf.paramMap.get('module');
      const slug = leaf.paramMap.get('slug');

      if (slug) {
        const slugHuman = this.humanizeSlug(slug);
        const modHuman = mod ? this.humanizeSlug(mod) : null;
        t = modHuman ? `${slugHuman} — ${modHuman}` : slugHuman;
      }
    }

    // 3) Final fallback
    if (!t) t = PUBLIC_APP_NAME;

    // 4) Normalize suffix
    const brandLower = PUBLIC_APP_NAME.toLowerCase();
    if (!t.toLowerCase().includes(brandLower)) {
      t = `${t} | ${PUBLIC_APP_NAME}`;
    }

    this.title.setTitle(t);
  }

  private getLeaf(r: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let cur = r;
    while (cur.firstChild) cur = cur.firstChild;
    return cur;
  }

  private humanizeSlug(s: string): string {
    return (s ?? '')
      .replace(/[-_]+/g, ' ')
      .trim()
      .replace(/\b\w/g, (m) => m.toUpperCase());
  }
}
